import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_SERIES = false


var SIMULATE_ERROR_RESP = { response: { status: 500 } }
var SIMULATE_SERIES_ERROR = false
export function simulateSeriesError(sim) {
    SIMULATE_SERIES_ERROR = sim
}


/*
 * Series Actions
 * 
 */

export function fetchSeriesList(dispatch) {
    let cmd = 'FETCH_SERIES_LIST'

    if (EMULATION_ALL || EMULATION_MODE_SERIES)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productSeriesId: 1,
                            name: 'CT1',
                            lastUpdatedAt: '2018-07-27T16:28:44.175',
                            createdBy: 'Mattias Svensson',
                            published: 1,
                            active: false
                        },
                        {
                            productSeriesId: 2,
                            name: 'CT2',
                            lastUpdatedAt: '2018-07-27T16:28:44.175',
                            createdBy: 'Susan Artes',
                            published: 0,
                            active: false
                        },
                        {
                            productSeriesId: 3,
                            name: 'CT3',
                            lastUpdatedAt: '2018-07-27T16:28:44.175',
                            createdBy: 'Jim Grace',
                            published: 1,
                            active: true
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {

            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ProductSeries'), { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_SERIES_ERROR)
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchSerError(dispatch) {

    dispatch(
        {
            type: 'FETCH_SER_ERROR',
        }
    )
}

export function createSer(ser) {
    let cmd = 'CREATE_SERIES'

    if (EMULATION_ALL || EMULATION_MODE_SERIES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: ser
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {

            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('ProductSeries'), JSON.stringify(ser), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchSer(id) {
    let cmd = 'FETCH_SERIES'

    if (EMULATION_ALL || EMULATION_MODE_SERIES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productSeriesId: id,
                        name: 'test',
                        notes: "",
                        published: id % 2,
                        reicoSkuBricks: [
                            { name: "Lamination" },
                            { name: "Length" },
                            { name: "Depth" },
                            { name: "Thickness" }
                        ],
                        supplementalDataBricks: [
                            { name: "Length" },
                            { name: "Width" }
                        ],
                        displayAttributesBricks: [
                            { name: "Species" },
                            { name: "Length" },
                            { name: "Lamination" },
                            { name: "Edge" }
                        ],
                        filteredAttributesBricks: [
                            { name: "Species" },
                            { name: "Length" },
                            { name: "Lamination" },
                            { name: "Edge" }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ProductSeries/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_SERIES_ERROR)
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateSer(id, ser) {
    let cmd = 'UPDATE_SERIES'

    if (EMULATION_ALL || EMULATION_MODE_SERIES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: ser
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('ProductSeries/') + id, JSON.stringify(ser), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    if (SIMULATE_SERIES_ERROR)
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: SIMULATE_ERROR_RESP
                            }
                        )
                    else
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorSer(dispatch) {

    dispatch(
        {
            type: 'SER_ERROR',
        }
    )
}